module.exports = __webpack_public_path__ + "static/media/bit.b1f8f5d1.svg";